import { render, staticRenderFns } from "./Info3.vue?vue&type=template&id=ab0071fc&scoped=true&"
import script from "./Info3.vue?vue&type=script&lang=js&"
export * from "./Info3.vue?vue&type=script&lang=js&"
import style0 from "./Info3.vue?vue&type=style&index=0&id=ab0071fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0071fc",
  null
  
)

export default component.exports